import { Children, cloneElement, ReactElement, ReactNode } from 'react';

import { RuleMessage } from '@app/domain-interfaces';
import { Popover } from '@app/web-components';

import { EligibilityPanel } from '../panels';

export type EligibilityPopoverProps = {
  messages: RuleMessage[];
  children: ReactNode;
};

export const EligibilityPopover = ({ messages, children }: EligibilityPopoverProps) => {
  const child = Children.only(children) as ReactElement;

  return (
    <Popover.Popover2Modal
      placement="right"
      title="Eligibility Information"
      content={<EligibilityPanel messages={messages} />}
      popoverWidth={800}
      children={cloneElement(child, { ...child.props, style: { ...child.props?.style, cursor: 'pointer' } })}
    />
  );
};
